(() => {
  if (window.chungtaCurrencyControls) return;
  window.chungtaCurrencyControls = true;

  const preferenceKey = 'ct-display-currency';
  const controlSelector = '[data-ct-currency-control]';
  const locale = document.documentElement.lang || 'zh-TW';
  const priority = locale.startsWith('zh') ? ['TWD', 'USD', 'VND', 'CNY'] : locale.startsWith('vi') ? ['VND', 'USD', 'TWD', 'CNY'] : ['USD', 'VND', 'EUR', 'GBP', 'TWD', 'CNY'];
  const popover = document.createElement('div');
  popover.id = 'ct-currency-popover';
  popover.hidden = true;
  popover.setAttribute('popover', 'manual');
  let widget;
  let trigger;
  let frame;
  let preparedList;
  let widgetObserver;
  let consumeEscapeKeyUp = false;

  const storage = {
    get(key) { try { return localStorage.getItem(key); } catch { return null; } },
    set(key, value) { try { localStorage.setItem(key, value); } catch {} },
  };
  const config = window.baCurr?.config;
  const supported = new Set((config?.chosen_cur || []).flatMap(item => Object.keys(item)));
  if (config?.user_curr) supported.add(config.user_curr);
  const preference = storage.get(preferenceKey);
  if (preference && supported.has(preference)) {
    try { sessionStorage.setItem('bacurr_user_cur', JSON.stringify(preference)); } catch {}
  }

  let displayNames;
  try { displayNames = new Intl.DisplayNames([locale], {type: 'currency'}); } catch {}
  const currentCurrency = () => widget?.querySelector('.ba-chosen')?.textContent.trim() || window.baCurr?.config?.final_currency || 'VND';
  const options = () => [...(widget?.querySelectorAll('.bacurr-dropdown-choices > li') || [])];
  const nativeChoice = () => widget?.querySelector('.bacurr-choiceDesign');

  function sync() {
    const code = currentCurrency();
    document.querySelectorAll(controlSelector).forEach(control => {
      const button = control.querySelector('[data-ct-currency-trigger]');
      const label = control.dataset.ctCurrencyLabel;
      const value = control.querySelector('[data-ct-currency-code]');
      if (value && value.textContent !== code) value.textContent = code;
      button.disabled = !widget;
      button.setAttribute('aria-label', label + ': ' + code);
      button.setAttribute('aria-expanded', String(button === trigger && !popover.hidden));
      control.setAttribute('aria-busy', String(!widget));
      if (widget) control.dataset.ctCurrencyReady = 'true';
    });
    options().forEach(option => option.setAttribute('aria-selected', String(option.getAttribute('rel') === code)));
    if (!popover.hidden && !nativeChoice()?.classList.contains('active')) close(true);
  }

  function prepareOptions(list) {
    if (preparedList === list) return;
    preparedList = list;
    const base = window.baCurr?.config?.user_curr;
    const select = widget.querySelector('select.bacurr');
    // Reuse Nova's bound handlers for the store currency, which its default list omits.
    if (base && !options().some(option => option.getAttribute('rel') === base) && list.firstElementChild && window.bacurr$) {
      const copy = window.bacurr$(list.firstElementChild).clone(true, true)[0];
      copy.id = base;
      copy.setAttribute('rel', base);
      const flag = copy.querySelector('.baCountry');
      if (flag) flag.className = 'baCountry baCountry-' + base;
      list.appendChild(copy);
      if (select && ![...select.options].some(option => option.value === base)) select.add(new Option(base, base));
    }
    list.id = 'ct-currency-options';
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', document.querySelector(controlSelector)?.dataset.ctCurrencyLabel || 'Currency');
    const items = options();
    items.forEach(option => {
      const code = option.getAttribute('rel');
      const text = option.querySelector('.curChoice');
      let name;
      try { name = displayNames?.of(code); } catch {}
      if (text && name) text.textContent = code + ' - ' + name;
      option.setAttribute('role', 'option');
      option.tabIndex = -1;
    });
    const rank = code => priority.includes(code) ? priority.indexOf(code) : priority.length;
    items.sort((a, b) => rank(a.getAttribute('rel')) - rank(b.getAttribute('rel'))).forEach(option => list.appendChild(option));
  }

  function reconcile() {
    frame = undefined;
    const candidate = document.querySelector('.bacurr-cur-blocker');
    const list = candidate?.querySelector('.bacurr-dropdown-choices');
    if (!candidate || !list) return;
    if (candidate !== widget || !widgetObserver) {
      widget = candidate;
      if (!popover.isConnected) document.body.appendChild(popover);
      if (widget.parentElement !== popover) popover.appendChild(widget);
      widgetObserver?.disconnect();
      widgetObserver = new MutationObserver(schedule);
      widgetObserver.observe(widget, {childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style']});
    }
    prepareOptions(list);
    sync();
  }

  function schedule() {
    if (frame === undefined) frame = requestAnimationFrame(reconcile);
  }

  function position() {
    if (!trigger || popover.hidden) return;
    const bounds = trigger.getBoundingClientRect();
    const width = popover.offsetWidth;
    const height = popover.offsetHeight;
    const viewport = window.visualViewport;
    const viewWidth = viewport?.width || window.innerWidth;
    const viewHeight = viewport?.height || window.innerHeight;
    const left = Math.max(12, Math.min(bounds.right - width, viewWidth - width - 12));
    const top = bounds.bottom + height + 8 <= viewHeight - 12 ? bounds.bottom + 8 : Math.max(12, bounds.top - height - 8);
    popover.style.left = left + 'px';
    popover.style.top = top + 'px';
  }

  function open(button, keyboard = false) {
    if (!widget || button.disabled) return;
    if (trigger === button && !popover.hidden) { close(true); return; }
    close(false);
    document.dispatchEvent(new CustomEvent('ct:selector-open', {detail: {selector: 'currency'}}));
    trigger = button;
    // Keep the panel inside the drawer's focus trap while using the top layer.
    (button.closest('.menu-drawer') || document.body).appendChild(popover);
    popover.hidden = false;
    if (typeof popover.showPopover === 'function') popover.showPopover({source: button});
    if (!nativeChoice().classList.contains('active')) nativeChoice().click();
    sync();
    position();
    if (keyboard) (options().find(option => option.getAttribute('aria-selected') === 'true') || options()[0])?.focus();
  }

  function close(restoreFocus) {
    const previous = trigger;
    trigger = undefined;
    if (typeof popover.hidePopover === 'function' && popover.matches(':popover-open')) popover.hidePopover();
    popover.hidden = true;
    if (nativeChoice()?.classList.contains('active')) nativeChoice().click();
    document.querySelectorAll('[data-ct-currency-trigger]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    if (restoreFocus && previous?.isConnected) previous.focus({preventScroll: true});
  }

  function start() {
    if (!document.querySelector(controlSelector) || config?.enabled === false) return;
    document.documentElement.classList.add('ct-currency-enhanced');
    document.body.appendChild(popover);
    document.addEventListener('ct:selector-open', event => {
      if (event.detail?.selector !== 'currency') close(false);
    });
    const bodyObserver = new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node instanceof Element && (node.matches('.bacurr-cur-blocker, .bacurr-cur-block, ' + controlSelector) || node.querySelector('.bacurr-cur-blocker, .bacurr-cur-block, ' + controlSelector))))) schedule();
    });
    bodyObserver.observe(document.body, {childList: true, subtree: true});
    document.addEventListener('click', event => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-ct-currency-trigger]');
      if (button) {
        event.preventDefault();
        event.stopPropagation();
        open(button);
      } else if (popover.contains(event.target)) {
        const option = event.target.closest('li[rel]');
        if (option) storage.set(preferenceKey, option.getAttribute('rel'));
      } else if (!popover.hidden) close(false);
    }, true);
    document.addEventListener('keydown', event => {
      if (!(event.target instanceof Element)) return;
      const button = event.target.closest('[data-ct-currency-trigger]');
      if (button && ['ArrowDown', 'ArrowUp'].includes(event.key)) {
        event.preventDefault();
        event.stopPropagation();
        open(button, true);
        return;
      }
      if (popover.hidden || (!popover.contains(event.target) && event.target !== trigger)) return;
      const items = options();
      const index = items.indexOf(document.activeElement);
      if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
        event.preventDefault();
        event.stopPropagation();
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items[next]?.focus();
      } else if (event.key === 'Enter' || event.key === ' ') {
        if (index >= 0) { event.preventDefault(); event.stopPropagation(); items[index].click(); }
      } else if (event.key === 'Escape') {
        event.preventDefault();
        event.stopPropagation();
        consumeEscapeKeyUp = true;
        close(true);
      } else if (event.key === 'Tab') close(true);
    }, true);
    // The theme closes the drawer on keyup; Escape should close this panel first.
    document.addEventListener('keyup', event => {
      if (event.key === 'Escape' && consumeEscapeKeyUp) {
        consumeEscapeKeyUp = false;
        event.stopPropagation();
      }
    }, true);
    document.addEventListener('toggle', event => {
      if (event.target instanceof HTMLDetailsElement && event.target.id === 'Details-menu-drawer-container' && !event.target.open) close(false);
    }, true);
    window.addEventListener('resize', () => close(false), {passive: true});
    document.addEventListener('scroll', event => {
      if (!popover.hidden && event.target instanceof Element && !popover.contains(event.target)) position();
    }, {capture: true, passive: true});
    document.addEventListener('shopify:section:load', schedule);
    reconcile();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
